import { useQuery } from '@tanstack/react-query';

import { FaceIdRegistrationStatus } from '@/features/face-id-profiles/enums';
import { QUERY_KEYS } from '@/constants';
import { FaceIdProfileDetailsService } from '@/features/face-id-profiles/services';

export const useFaceIdFacialDataQuery = (
  profileId: string,
  registrationStatus: FaceIdRegistrationStatus,
) => {
  return useQuery({
    queryKey: QUERY_KEYS.faceIdProfileFacial(profileId),
    queryFn: async () => {
      const response = await FaceIdProfileDetailsService.GetFaceIdProfileFacialData(profileId);
      return response.data;
    },
    enabled: !!profileId && registrationStatus === FaceIdRegistrationStatus.Registered,
  });
};
